import {useState, useEffect} from 'react';
import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/material.css';


export const RequestDemoForm = () => {

    const __ = (text = '') => {
        let translated_text = text;
        if (text && data_value_scripts_object[text]) {
            translated_text = data_value_scripts_object[text];
        }
        return translated_text;
    }

    const wp_ajax_url = data_value_scripts_object.wp_ajax_url;

    const phone_country = (data_value_scripts_object.site_country && data_value_scripts_object.site_country == 'sa') ? 'sa' : 'eg'

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    }

    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    const redirectToUrlWithQuery = (queryString) => {
        const currentUrl = window.location.origin + window.location.pathname;
        window.location.href = currentUrl + queryString;
    }

    const [requestDemoError, setRequestDemoError] = useState('');
    const [requestDemoLoading, setRequestDemoLoading] = useState(false);
    const [requestDemoSent, setRequestDemoSent] = useState(false);
    const [requestDemoInputs, setRequestDemoInputs] = useState({
        rdFullName: '',
        rdCompanyName: '',
        rdNumberOfEmployees: '1-10',
        rdEmail: '',
        rdPhoneNumber: ''
    });
    const [requestDemoInputsErrors, setRequestDemoInputsErrors] = useState({
        rdFullName: '',
        rdCompanyName: '',
        rdNumberOfEmployees: '',
        rdEmail: '',
        rdPhoneNumber: ''
    });


    const handleRequestDemoInputsChange = (fieldName, value) => {
        setRequestDemoInputs({...requestDemoInputs, [fieldName]: value,});
    };

    const requestDemoFormValidations = (form) => {
        const errors = {};
        if (!form.rdFullName || !form.rdFullName.trim()) {
            errors.rdFullName = __('Full name required');
        } else {
            if (form.rdFullName.trim().length < 3) {
                errors.rdFullName = __('Minimum 3 characters');
            }
        }
        if (!form.rdCompanyName || !form.rdCompanyName.trim()) {
            errors.rdCompanyName = __('Company name required');
        } else {
            if (form.rdCompanyName.trim().length < 3) {
                errors.rdCompanyName = __('Minimum 3 characters');
            }
        }
        if (!form.rdEmail || !form.rdEmail.trim()) {
            errors.rdEmail = __('Email required');
        } else {
            if (!validateEmail(form.rdEmail)) {
                errors.rdEmail = __('Must be valid email');
            }
        }
        if (!form.rdPhoneNumber) {
            errors.rdPhoneNumber = __('Phone number required');
        } else {
            if (form.rdPhoneNumber?.length < 9) {
                errors.rdPhoneNumber = __('Phone number must be at least 9 digits');
            }
        }
        return errors;
    }

    const requestDemoInputsSubmit = (e) => {
        e.preventDefault();
        const newErrors = requestDemoFormValidations(requestDemoInputs);
        setRequestDemoInputsErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            setRequestDemoSent(false);
            setRequestDemoLoading(true);
            jQuery.ajax({
                type: 'POST',
                url: wp_ajax_url,
                data: {
                    action: 'dv_request_demo_action',
                    nonce: data_value_scripts_object.data_value_nonce,
                    rdFullName: requestDemoInputs.rdFullName,
                    rdCompanyName: requestDemoInputs.rdCompanyName,
                    rdNumberOfEmployees: requestDemoInputs.rdNumberOfEmployees,
                    rdEmail: requestDemoInputs.rdEmail,
                    rdPhoneNumber: requestDemoInputs.rdPhoneNumber
                },
                success: async (response) => {
                    setRequestDemoLoading(false);
                    setRequestDemoSent(true);
                    setRequestDemoInputs({
                        rdFullName: '',
                        rdCompanyName: '',
                        rdNumberOfEmployees: '1-10',
                        rdEmail: '',
                        rdPhoneNumber: ''
                    });
                    // redirectToUrlWithQuery('?sent=true');
                },
                error: (error) => {
                    setRequestDemoLoading(false);
                    setRequestDemoSent(false);
                    setRequestDemoInputs({
                        rdFullName: '',
                        rdCompanyName: '',
                        rdNumberOfEmployees: '1-10',
                        rdEmail: '',
                        rdPhoneNumber: ''
                    });
                    // setRequestDemoLoading(false);
                    // if (error.status === 403) {
                    //     setRequestDemoError(__('Error 403 Access Denied'));
                    // } else {
                    //     if (error.responseJSON) {
                    //         setRequestDemoError(error.responseJSON.data);
                    //     } else {
                    //         setRequestDemoError(error.statusText);
                    //     }
                    // }
                }
            });
        }

    }

    useEffect(() => {
        if (getQueryParam('sent') === 'true') {
            setRequestDemoSent(true);
        }
    }, [requestDemoSent]);

    return (
        <>
            {
                requestDemoSent ?
                    <div className="request-demo-page-form-message">
                        <div>
                            <svg width="114" height="83" className="animate__animated animate__fadeInDown animate__fast" viewBox="0 0 114 83" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M36.6875 25.2493C36.6875 17.0226 43.3566 10.3535 51.5833 10.3535H94.9167C103.144 10.3535 109.812 17.0226 109.812 25.2493V57.7494C109.812 65.9762 103.144 72.6452 94.9167 72.6452H51.5833C43.3566 72.6452 36.6875 65.9762 36.6875 57.7494V25.2493ZM44.8798 24.291C44.8355 24.6041 44.8125 24.924 44.8125 25.2493V57.7494C44.8125 61.489 47.8437 64.5202 51.5833 64.5202H94.9167C98.6563 64.5202 101.688 61.489 101.688 57.7494V25.2493C101.688 24.924 101.665 24.6041 101.62 24.291L78.0378 47.8737C75.3934 50.5176 71.1066 50.5176 68.4622 47.8737L44.8798 24.291ZM50.6251 18.5458L73.25 41.1706L95.8749 18.5458C95.5618 18.5015 95.2422 18.4785 94.9167 18.4785H51.5833C51.2578 18.4785 50.9382 18.5015 50.6251 18.5458Z"
                                      fill="#0033FA"/>
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M12.3125 19.834C12.3125 17.5903 14.1314 15.7715 16.375 15.7715H24.5C26.7436 15.7715 28.5625 17.5903 28.5625 19.834C28.5625 22.0776 26.7436 23.8965 24.5 23.8965H16.375C14.1314 23.8965 12.3125 22.0776 12.3125 19.834ZM4.1875 41.5007C4.1875 39.2571 6.00636 37.4382 8.25 37.4382H24.5C26.7436 37.4382 28.5625 39.2571 28.5625 41.5007C28.5625 43.7442 26.7436 45.5632 24.5 45.5632H8.25C6.00636 45.5632 4.1875 43.7442 4.1875 41.5007ZM12.3125 63.1673C12.3125 60.9237 14.1314 59.1048 16.375 59.1048H24.5C26.7436 59.1048 28.5625 60.9237 28.5625 63.1673C28.5625 65.4109 26.7436 67.2298 24.5 67.2298H16.375C14.1314 67.2298 12.3125 65.4109 12.3125 63.1673Z"
                                      fill="#00BBB8"/>
                            </svg>
                            {/*<h3 className="animate__animated animate__fadeInUp animate__fast">{__('Thank you, our team will contact you within 3 business days.')}</h3>*/}
                            <h3 className="animate__animated animate__fadeInUp animate__fast">{__('Thank you. One of our representatives will contact you within 6–8 business hours.')}</h3>
                            <p className="animate__animated animate__fadeInUp animate__fast">{__('Our working hours are from Sunday to Thursday from 9 am to 5 pm.')}</p>
                        </div>
                    </div>
                    :
                    <form method="post" action={wp_ajax_url} className={(requestDemoLoading) ? 'form-loading' : ''} onSubmit={requestDemoInputsSubmit}>
                        {requestDemoError ? <div className="alert alert-danger" style={{padding: '5px 12px 4px 12px', fontSize: '14px', fontWeight: '400'}}><i class="fa-regular fa-circle-exclamation me-1"></i> {requestDemoError}</div> : null}
                        <div className="form-group">
                            <label htmlFor="rdFullName" className="form-label">{__('Full name')}</label>
                            <input type="text" className={`form-control ${requestDemoInputsErrors.rdFullName ? 'is-invalid' : ''}`} id="rdFullName"
                                   onChange={e => handleRequestDemoInputsChange('rdFullName', e.target.value)}
                                   value={requestDemoInputs.rdFullName}
                            />
                            <div className="invalid-feedback">{requestDemoInputsErrors.rdFullName}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="rdCompanyName" className="form-label">{__('Company name')}</label>
                            <input type="text" className={`form-control ${requestDemoInputsErrors.rdCompanyName ? 'is-invalid' : ''}`} id="rdCompanyName"
                                   onChange={e => handleRequestDemoInputsChange('rdCompanyName', e.target.value)}
                                   value={requestDemoInputs.rdCompanyName}

                            />
                            <div className="invalid-feedback">{requestDemoInputsErrors.rdCompanyName}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="rdNumberOfEmployees" className="form-label">{__('Number of employees')}</label>
                            <select className="form-select pointer-event" id="rdNumberOfEmployees"
                                    onChange={e => handleRequestDemoInputsChange('rdNumberOfEmployees', e.target.value)}
                                    value={requestDemoInputs.rdNumberOfEmployees}
                            >
                                <option value="1-10">1 - 10</option>
                                <option value="11-50">11 - 50</option>
                                <option value="51-200">51 - 200</option>
                                <option value="201-500">201 - 500</option>
                                <option value="501-1000">501 - 1000</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="rdEmail" className="form-label">{__('Email')}</label>
                            <input type="email" className={`form-control ${requestDemoInputsErrors.rdEmail ? 'is-invalid' : ''}`} id="rdEmail"
                                   onChange={e => handleRequestDemoInputsChange('rdEmail', e.target.value)}
                                   value={requestDemoInputs.rdEmail}

                            />
                            <div className="invalid-feedback">{requestDemoInputsErrors.rdEmail}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="rdPhoneNumber" className="form-label">{__('Phone number')}</label>
                            <div className="ltr">
                                <PhoneInput
                                    country={phone_country}
                                    countryCodeEditable={false}
                                    preferredCountries={['sa', 'eg', 'ae', 'kw', 'iq', 'sd', 'ps']}
                                    excludeCountries={['il']}
                                    className={`${requestDemoInputsErrors.rdPhoneNumber ? 'is-invalid' : ''}`}
                                    onChange={phone => handleRequestDemoInputsChange('rdPhoneNumber', phone)}
                                    value={requestDemoInputs.rdPhoneNumber}
                                />
                            </div>
                            {requestDemoInputsErrors.rdPhoneNumber ? <div className="invalid-feedback d-block">{requestDemoInputsErrors.rdPhoneNumber}</div> : ''}
                        </div>
                        <div className="form-group mt-4">
                            <button type="submit" className="btn btn-primary">{__('Request a demo')} <i className="fa-regular fa-arrow-right"></i></button>
                        </div>
                        <p>
                            {__('Free trial')}
                            <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_995_43233)">
                                    <path d="M5.5 1C5.5 1 5.5 5 9.5 5M5.5 1C5.5 5 1.5 5 1.5 5M5.5 1V0M9.5 5C9.5 5 5.5 5 5.5 9M9.5 5H10.5M1.5 5C5.5 5 5.5 9 5.5 9M1.5 5H0.5M5.5 9V10" stroke="#4A6071"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_995_43233">
                                        <rect width="10" height="10" fill="white" transform="translate(0.5)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            {__('No credit card required')}
                        </p>
                    </form>
            }
        </>
    )
}